// Definição para o modal de busca de Tipos de Documento de Entrada
// Factory function - recebe filtros como parâmetros, sem magic strings

import { ST } from '@/constants/ST'

export const configBuscaDocumentoEntradaTipo = {
  label: 'Tipo de Documento de Entrada',
  placeholder: 'ID ou Nome...',
  titulo: 'Selecionar Tipo de Documento de Entrada',
  endpointApi: 'DocumentosEntradaTipos',
  idField: 'idTipoDocumentoEntrada',
  displayField: 'idTipoDocumentoEntrada',
  descField: 'nome',
  camposFiltro: [
    { label: 'Nome', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idTipoDocumentoEntrada', width: '8%' },
    { header: 'Nome', dataField: 'nome', width: '40%' },
    { header: 'Descrição', dataField: 'descricao', width: '52%' }
  ],
  filtrosFixos: {
    lstStatus: ST.Ativo
  }
}

export const criarConfigBuscaDocumentoEntradaTipo = (isInterno = null, lstStatus = ST.Ativo) => {
  const filtros = { lstStatus }
  if (isInterno === true || isInterno === false) {
    filtros.isInterno = isInterno
  }
  return {
    label: 'Tipo de Documento de Entrada',
    placeholder: 'ID ou Nome...',
    titulo: 'Selecionar Tipo de Documento de Entrada',
    endpointApi: 'DocumentosEntradaTipos',
    idField: 'idTipoDocumentoEntrada',
    displayField: 'idTipoDocumentoEntrada',
    descField: 'nome',
    camposFiltro: [
      { label: 'Nome', model: 'busca', tipo: 'text' }
    ],
    colunasGrid: [
      { header: 'ID', dataField: 'idTipoDocumentoEntrada', width: '8%' },
      { header: 'Nome', dataField: 'nome', width: '40%' },
      { header: 'Descrição', dataField: 'descricao', width: '52%' }
    ],
    filtrosFixos: filtros
  }
}
